export default __webpack_public_path__ + "static/media/instapng.552f0914.png";